import { render, staticRenderFns } from "./AreaAffectedEdit.vue?vue&type=template&id=3d66665b&scoped=true&"
import script from "./AreaAffectedEdit.vue?vue&type=script&lang=js&"
export * from "./AreaAffectedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d66665b",
  null
  
)

export default component.exports